<template>
    <v-app>
        <PromptTrackAndTrace />
        <keep-alive>
            <component :is="layout" />
        </keep-alive>
        <DialogSelectItem />
        <DialogSuccess />
        <footer>
            <PromptUpdateApp />
            <PromptCookieConsent />
        </footer>
    </v-app>
</template>

<script>
import DialogSelectItem from '@/components/DialogSelectItem';
import DialogSuccess from '@/components/DialogSuccess';
import PromptUpdateApp from '@/components/PromptUpdateApp';
import PromptCookieConsent from '@/components/PromptCookieConsent';
import PromptTrackAndTrace from '@/components/PromptTrackAndTrace';
import { mapState } from 'vuex';

// Load all layouts dynamically.
const requireContext = require.context('./views/layouts', false, /.*\.vue$/);

const layouts = requireContext.keys()
  .map((file) => [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file).default])
  .reduce((allLayouts, [name, layout]) => {
    allLayouts[name] = layout;
    return allLayouts;
  }, {});

export default {
  name: 'App',

  components: {
    ...layouts,
    DialogSelectItem,
    DialogSuccess,
    PromptCookieConsent,
    PromptUpdateApp,
    PromptTrackAndTrace,
  },

  computed: {
    layout() {
      return this.$route.meta.layout;
    },

    ...mapState({
      selectedItem: (state) => state.menu.selectedItem,
    }),
  },
};
</script>

<style lang="scss">

</style>
